import React, { useRef, useState, useEffect } from 'react'
import {
  getTimeSpent,
  getTimeSpentOverall,
  getSubmitDate
} from '../utils/TimerUtils'
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded'
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded'
import { CaretDown, CaretUp } from '@carbon/icons-react'
import { SmartSlideBaseScreen } from './SmartSlideBaseScreen'
import { BotAssistSettings } from '../UIUtilsFiles/BotAssistSettings'
import { TUTOR_BOT } from '../constants'

function SmartSlideMainScreen(props) {
  const { user, currentLessonUnitDistId } = props // from redux state
  const {
    activityDataFromParent,
    isBgAudioPlayed,
    minutes,
    seconds,
    isActive,
    onToastTrigger,
    isPreview,
    isSequence,
    isClassroom,
    isMinimize
  } = props

  const {
    minutesPractice,
    secondsPractice,
    activitySaveClick,
    activitySaveType,
    activityResetType,
    canvasAreaDimensions
  } = props //values from parent activity screen
  const {
    getStudentWorkedDataFromChild,
    getStudentCurrentScore,
    getCurrentSlideIndex,
    getActivityResetStatus,
    getTutorTalking,
    getValidationFeedback,
    getActivityLoaded
  } = props //values to parent activity screen

  //Activity data
  const [currentActivity, setCurrentActivity] = useState({})
  const {
    ActivityJson,
    Completed,
    SlideID,
    ActivityType,
    ContentID,
    Feedback,
    Status,
    SlideName,
    AppName,
    ContentName,
    WorkJson
  } = currentActivity
  const SAVE_MODE = { SAVE: 'SAVE', SUBMIT: 'SUBMIT' }
  const IsReadonly = false
  const isPractice = ActivityType === 'practice' ? true : false
  let isBackButtonClicked = false
  //Smart slide based variables
  const [smartSlideData, setSmartSlideData] = useState({})
  const [currentSlideIndex, setCurrentSlideIndex] = useState(-1)
  const [activityJson, setActivityJson] = useState({ InputControls: [] })
  const [controlsList, setControlsList] = useState([])
  const [success, setSuccess] = useState(false)
  const [validationVisible, setValidationVisible] = useState(false)
  const [fontFamily, setFontFamily] = useState('')
  const [fontStyle, setFontStyle] = useState(false)
  const [fontWeight, setFontWeight] = useState(false)
  const [oldJson, setOldJson] = useState(true)
  //Tutor variables
  const [botAudioData, setBotAudioData] = useState('')
  const [ttsData, setTtsData] = useState([])
  const [tutorialStart, setTutorialStart] = useState(false)
  const [isSubtitle, setIsSubtitle] = useState(true)
  const [isTutorPlayed, setIsTutorPlayed] = useState(false)
  const [ttsPlayType, setTtsPlayType] = useState('')
  const [feedbackType, setFeedbackType] = useState('')
  const [isAudioForcedStopped, setIsAudioForcedStopped] = useState(false)
  const [isAudioPlaying, setIsAudioPlaying] = useState(true)
  //Attempts and score variables
  const [attempts, setAttempts] = useState(0)
  const [attemptsPractice, setAttemptsPractice] = useState(0)
  const [currentScore, setCurrentScore] = useState(0)
  const [currentScoreApi, setCurrentScoreApi] = useState(0)
  const [currentScoreReset, setCurrentScoreReset] = useState(0)
  const [cumulativeAverageScoreOld, setCumulativeAverageScoreOld] = useState(0)

  const [audioStop, setAudioStop] = useState(false)

  //Teacher feedback variables
  const [feedbackVisible, setFeedbackVisible] = useState(false)
  //Reset variables
  const [popupType, setPopupType] = useState('')
  const [confirmPopupVisible, setConfirmPopupVisible] = useState(false)
  const [resetValue, setResetValue] = useState(0)
  const [totalResetOld, setTotalResetOld] = useState(0)
  const [totalResetPractice, setTotalResetPractice] = useState(0)
  const [isResetClick, setIsResetClick] = useState(false)
  //Hint variables
  const [hintMessage, setHintMessage] = useState('')
  const [hintVisible, setHintVisible] = useState(false)
  // Check Answer variables
  const [currentDisplayMode, setcurrentDisplayMode] = useState('normal')
  const isVerifyMode = currentDisplayMode === 'verify'
  //Answer Explanation variables
  const [explanationVisible, setExplanationVisible] = useState(false)
  const [explanationClick, setExplanationClick] = useState(false)
  const [explanationText, setExplanationText] = useState('')
  const [explanationStatus, setExplanationStatus] = useState(false)

  const [initial, setInitial] = useState(true)
  const [initialApiCall, setInitialApiCall] = useState(true)
  const [isMedia, setIsMedia] = useState(false)

  //Hamburger menu variables
  const [isPalleteClose, setIsPalleteClose] = useState(false)
  const [previousSlideIndexes, setPreviousSlideIndexes] = useState([])
  const [nextSlideIndexes, setNextSlideIndexes] = useState([])

  useEffect(() => {
    if (initial) {
      setTimeout(() => {
        setInitial(false)
      }, 2000)
    }
  }, [initial])

  useEffect(() => {
    if (isBgAudioPlayed) {
      setInitial(true)
      setCurrentActivity(activityDataFromParent)
    } else {
      setcurrentDisplayMode('normal')
    }
  }, [isBgAudioPlayed])

  useEffect(() => {
    if (isActive && Object.keys(currentActivity).length > 0) {
      let ccData = JSON.parse(ActivityJson)
      setActivityJson({
        InputControls: ccData.InputControls,
        TotalScore: ccData.TotalScore
      })
      setInitial(true)
      setInitialApiCall(true)
      setCurrentSlideIndex(0)
      getActivityLoaded(false)
    }
  }, [isActive, currentActivity])

  useEffect(() => {
    if (currentSlideIndex >= 0) {
      setAudioStop(true)
      updateSmartSlideData(currentSlideIndex)
      let previouSlides = []
      for (let index = 0; index < currentSlideIndex; index++) {
        previouSlides.push(index)
      }
      setPreviousSlideIndexes(previouSlides)
      let nextSlides = []
      for (
        let index = currentSlideIndex + 1;
        index < activityJson.InputControls.length;
        index++
      ) {
        nextSlides.push(index)
      }
      setNextSlideIndexes(nextSlides)
    }
  }, [currentSlideIndex])

  function updateSmartSlideData(currentActiveSlide) {
    if (currentActiveSlide === 0) {
    }
    let ccData = JSON.parse(ActivityJson)
    let allSlides = ccData.InputControls

    setTimeout(() => {
      setAnimeClick(false)
      setAudioStop(false)
      setSmartSlideData(allSlides[currentActiveSlide])
      getCurrentSlideIndex(allSlides[currentActiveSlide])
      setInitial(true)
    }, 500)

    if (
      allSlides[currentActiveSlide].PluginName &&
      (allSlides[currentActiveSlide].PluginName === 'HotspotImages' ||
        allSlides[currentActiveSlide].PluginName === 'EnrichedAudio' ||
        allSlides[currentActiveSlide].PluginName === 'EnrichedPlayer' ||
        allSlides[currentActiveSlide].PluginName === 'EnrichedPDF' ||
        allSlides[currentActiveSlide].PluginName === 'Visor3D' ||
        allSlides[currentActiveSlide].PluginName === 'Webpage' ||
        allSlides[currentActiveSlide].PluginName === 'H5P')
    ) {
      setIsMedia(true)
    } else {
      setIsMedia(false)
    }
  }

  useEffect(() => {
    if (Object.keys(smartSlideData).length > 0) {
      checkTutorInstructions()
    }
  }, [smartSlideData])

  //check tutor message is available and play
  function checkTutorInstructions() {
    let botTtsData = getTutorAudio()
    if (botTtsData.tutorTtsAudio !== '') {
      setTtsPlayType(TUTOR_BOT)
      setBotAudioData(botTtsData.tutorTtsAudio)
      setTutorialStart(true)
    } else {
      setTutorialStart(false)
      setIsTutorPlayed(true)
    }
    if (botTtsData.tutorTtsText !== '') {
      setTtsData(botTtsData.tutorTtsText)
    }
  }

  //Get initial instructions data
  function getTutorAudio() {
    const exercise = smartSlideData
    console.log('exercise', exercise)
    let tutorBotData = {
      tutorTtsAudio: '',
      tutorTtsText: []
    }
    if (exercise.SpeechAudioData) {
      let activityInitialInstruction = exercise.SpeechAudioData
      if (activityInitialInstruction.speechAudioLink) {
        tutorBotData.tutorTtsAudio = activityInitialInstruction.speechAudioLink
      }
      if (activityInitialInstruction.speechAudioLink) {
        tutorBotData.tutorTtsText = activityInitialInstruction.speechData
      }
    }
    return tutorBotData
  }

  useEffect(() => {
    if (isTutorPlayed) {
      setBotAudioData('')
      setWorkJsonData()
    }
  }, [isTutorPlayed])

  function setWorkJsonData() {
    if (Object.keys(smartSlideData).length !== 0 && initialApiCall) {
      //set hint message and font style for the slide
      const hintText = smartSlideData.SequenceHint
      setHintMessage(hintText)
      const fontFamily = smartSlideData.FontStyle
      let fontStyle = smartSlideData.Italic
      let fontWeight = smartSlideData.Bold
      if (fontStyle === 'True') {
        fontStyle = true
      } else {
        fontStyle = false
      }
      if (fontWeight === 'True') {
        fontWeight = true
      } else {
        fontWeight = false
      }
      setFontFamily(fontFamily)
      setFontStyle(fontStyle)
      setFontWeight(fontWeight)
      //set work json for slide
      let condition =
        WorkJson !== '' &&
        JSON.parse(WorkJson).filter(
          (e) => e.ContentID === ContentID && e.ModeName === 'SmartSlide'
        ).length > 0
      if (condition) {
        let workJson = undefined
        let indexOfSlide = -1
        indexOfSlide = JSON.parse(WorkJson).findIndex(
          (obj) => obj.ContentID === ContentID && obj.ModeName === 'SmartSlide'
        )
        workJson = JSON.parse(WorkJson)[indexOfSlide]

        setOldJson(true)
        setAttemptsPractice(workJson.Attempts)
        setAttempts(workJson.AttemptsOverall ? workJson.AttemptsOverall : 0)
        setCurrentScore(workJson.Score ? workJson.Score : 0)
        setCurrentScoreReset(workJson.ResetScore ? workJson.ResetScore : 0)
        setCumulativeAverageScoreOld(
          workJson.CumulativeAverageScoreOld
            ? workJson.CumulativeAverageScoreOld
            : 0
        )
        setControlsList(workJson.listControls)
        setTotalResetPractice(
          workJson.TotalResetPractice ? workJson.TotalResetPractice : 0
        )

        setTotalResetOld(workJson.TotalResetOld ? workJson.TotalResetOld : 0)
      }
      setInitialApiCall(false)
    }
  }

  //handled attempts when user hit answer learnpods
  function handleAttemptsChange() {
    setAttempts((attempts) => attempts + 1)
    setAttemptsPractice((attemptsPractice) => attemptsPractice + 1)
  }
  //handled answered data and storeed in controlslist
  function handleValueChange(
    ctlID,
    ctlValue,
    ctlScore,
    ctlTotalScore,
    ctlSortedArray,
    ctlTimer
  ) {
    let controlListCopy = [...controlsList]
    const presentIndex = controlListCopy.findIndex(
      (item) => item.CtlId === ctlID
    )
    if (presentIndex >= 0) {
      controlListCopy[presentIndex] = {
        CtlId: ctlID,
        CtlValue: ctlValue,
        CtlScore: ctlScore,
        CtlTotalScore: ctlTotalScore,
        CtlSortedArray: ctlSortedArray
      }
    } else {
      controlListCopy.push({
        CtlId: ctlID,
        CtlValue: ctlValue,
        CtlScore: ctlScore,
        CtlTotalScore: ctlTotalScore,
        CtlSortedArray: ctlSortedArray
      })
    }
    setOldJson(false)
    setControlsList(controlListCopy)
  }

  useEffect(() => {
    if (controlsList) {
      if (!oldJson) {
        let scoreTaken = 0
        controlsList.map((c, index) => {
          scoreTaken = scoreTaken + c.CtlScore
        })
        setCurrentScore(parseFloat(scoreTaken.toFixed(1)))
        let modifyCurrentScore = 0
        let calculateScAt = calculateTotalComponents()
        if (calculateScAt < 1) {
          let modifyScore = Math.round(
            parseFloat(scoreTaken.toFixed(1)) * calculateScAt
          )
          modifyCurrentScore = modifyScore
        } else {
          modifyCurrentScore = parseFloat(scoreTaken.toFixed(1))
        }
        setCurrentScoreApi(currentScoreReset + modifyCurrentScore)
        setOldJson(false)
      }
    }
  }, [controlsList])

  useEffect(() => {
    getStudentCurrentScore(currentScore)
  }, [currentScore, currentScoreApi])

  function handleSuccessChange(successValue) {
    if (isPractice) {
      if (successValue) {
        getValidationFeedback('success', true)
      } else {
        getValidationFeedback('failure', true)
      }
      setSuccess(successValue)
    }
  }

  function funcReset() {
    setCurrentScore(0)
    setControlsList([])
    setResetValue(1)
    setCurrentSlideIndex(0)
    setInitial(true)
    setAudioStop(true)
    setExplanationClick(false)
    getActivityResetStatus()
  }

  function funcResetPractice() {
    setAudioStop(true)
    let ccData = JSON.parse(ActivityJson)
    let totalScore = ccData.TotalScore
    let calculateScAt = calculateTotalComponents()
    let modifyCurrentScore = 0
    if (calculateScAt < 1) {
      let modifyScore = Math.round(currentScore * calculateScAt)
      modifyCurrentScore = modifyScore
    } else {
      modifyCurrentScore = currentScore
    }
    setCurrentScoreReset(
      (currentScoreReset) => currentScoreReset + modifyCurrentScore
    )
    setControlsList([])
    setAttemptsPractice(0)
    let tempScoreAverage = 0
    if (totalScore && totalScore !== 0) {
      tempScoreAverage =
        (currentScoreApi / ((totalResetPractice + 1) * totalScore)) * 100
    }
    setCumulativeAverageScoreOld(tempScoreAverage)
    setTotalResetOld(totalResetPractice + 1)
    setTotalResetPractice((totalResetPractice) => totalResetPractice + 1)
    setCurrentScore(0)
    setCurrentSlideIndex(0)
    setIsResetClick(true)
    setTimeout(() => {
      setIsResetClick(false)
    }, 1000)
    setInitial(true)

    setExplanationClick(false)
    setcurrentDisplayMode('normal')
    getActivityResetStatus()
  }

  function calculateAverage() {
    let ccData = JSON.parse(ActivityJson)
    let totScoreAct = ccData.TotalScore
    let overallAverageScore = 0
    let modifyCurrentScore = 0
    if (totScoreAct && totScoreAct !== 0) {
      let calculateScAt = calculateTotalComponents()
      if (calculateScAt < 1) {
        let modifyScore = Math.round(currentScore * calculateScAt)
        modifyCurrentScore = modifyScore
      } else {
        modifyCurrentScore = currentScore
      }
      let currentAverageScore = Math.round(
        (modifyCurrentScore / totScoreAct) * 100
      )
      if (cumulativeAverageScoreOld === 0) {
        overallAverageScore = Math.round(
          (modifyCurrentScore / totScoreAct) * 100
        )
      } else {
        overallAverageScore = Math.round(
          (cumulativeAverageScoreOld * totalResetOld + currentAverageScore) /
            (totalResetPractice + 1)
        )
      }
    }
    return overallAverageScore
  }

  function scoreForPractice() {
    let modifyCurrentScore = 0
    let calculateScAt = calculateTotalComponents()
    if (calculateScAt < 1) {
      let modifyScore = Math.round(currentScore * calculateScAt)
      modifyCurrentScore = modifyScore
    } else {
      modifyCurrentScore = currentScore
    }
    return modifyCurrentScore
  }

  function calculateTotalComponents() {
    const exercise = JSON.parse(ActivityJson)
    let noOfComponents = 0
    if (AppName === 'SmartSlide') {
      noOfComponents = exercise.InputControls.length
    }
    let calculateScAt = 0
    if (attemptsPractice !== 0) {
      calculateScAt = noOfComponents / attemptsPractice
    }

    return calculateScAt
  }

  useEffect(() => {
    // knovoHelpClose();
    if (activityResetType === 'resetPractice') {
      funcResetPractice()
    } else if (activityResetType === 'resetTest') {
      funcReset()
    }
  }, [activityResetType])

  //save studentDataCall
  useEffect(() => {
    if (activitySaveClick) {
      setAudioStop(true)
      getStudentWork()
    }
  }, [activitySaveClick])

  function getStudentWork() {
    let workData = {}
    if (IsReadonly) {
      workData = {
        ContentID: ContentID,
        ModeName: 'SmartSlide',
        TimeTaken: minutes + ':' + seconds
      }
    } else {
      //Attempts-current
      //AttemptsPractice-cumulative
      workData = {
        ContentID: ContentID,
        ModeName: 'SmartSlide',
        Score: currentScore,
        TimeTaken: minutesPractice + ':' + secondsPractice,
        Attempts: attemptsPractice,
        listControls: controlsList,
        TotalScore: isPractice ? currentScoreApi : currentScore,
        TimeTakenOverall: minutes + ':' + seconds,
        AttemptsOverall: attempts,
        TotalResetPractice: totalResetPractice,
        ResetScore: currentScoreReset,
        CumulativeAverageScoreOld: cumulativeAverageScoreOld,
        TotalResetOld: totalResetOld,
        Platform: 'Web'
      }
    }
    let allWorkData = []

    if (WorkJson === '') {
      allWorkData = [workData]
    } else {
      const workJson = JSON.parse(WorkJson)
      if (
        workJson.filter(
          (e) => e.ContentID === ContentID && e.ModeName === 'SmartSlide'
        ).length > 0
      ) {
        const workJsonCopy = [...workJson]
        const index = workJsonCopy.findIndex(
          (element) =>
            element.ContentID === ContentID && element.ModeName === 'SmartSlide'
        )
        workJsonCopy[index] = workData
        allWorkData = workJsonCopy
      } else {
        allWorkData = [...workJson, workData]
      }
    }
    if (activitySaveType === SAVE_MODE.SAVE) {
      setCurrentSlideIndex(-1)
    }

    const completed = activitySaveType === SAVE_MODE.SAVE ? 0 : 1
    const resetData = activitySaveType === SAVE_MODE.SAVE ? resetValue : 0
    let studentActivityData = JSON.stringify({
      LessonUnitDistID: currentLessonUnitDistId,
      StudentID: user.LoginID,
      DomainID: user.DomainID,
      ContentID: ContentID,
      Completed: completed,
      TotalPoints: !isPractice ? currentScore : scoreForPractice(),
      Attempts: attemptsPractice,
      Work: JSON.stringify([workData]),
      Ink: '',
      SpentTime: getTimeSpent(minutesPractice, secondsPractice, false),
      Reset: resetData,
      SubmitDate: getSubmitDate(),
      CumulativeAttempts: attempts,
      CumulativeTimeTaken: getTimeSpentOverall(minutes, seconds, false),
      CumulativeAverage: calculateAverage(),
      TotalTries: totalResetPractice + 1
    })
    getStudentWorkedDataFromChild(studentActivityData)
    if (activitySaveType === SAVE_MODE.SAVE) {
      setControlsList([])
    }
  }

  const [animeClick, setAnimeClick] = useState(false)

  function renderSlideFloating() {
    return (
      <div
        className={
          isPalleteClose
            ? 'slide-text-container slide-text-container-collapse'
            : 'slide-text-container'
        }
      >
        <div
          className='arrow-fwd-circle'
          style={{ width: '32px', height: '25px' }}
          onClick={() => {
            if (isBgAudioPlayed) {
              if (currentSlideIndex > 0) {
                setAnimeClick(true)
                setIsPalleteClose(false)
                setCurrentSlideIndex(
                  (currentSlideIndex) => currentSlideIndex - 1
                )
                setInitial(true)
              }
            }
          }}
        >
          <ArrowBackIosRoundedIcon
            style={{ width: '20px', height: '20px', color: '#4922fd' }}
          />
        </div>
        <span className='slide-text1'>
          Slide <span className='slide-text2'>{currentSlideIndex + 1}</span> of{' '}
          <span className='slide-text2'>
            {activityJson.InputControls.length}
          </span>
        </span>
        <div
          className='arrow-fwd-circle'
          style={{ width: '32px', height: '25px' }}
          onClick={() => {
            if (isBgAudioPlayed) {
              if (currentSlideIndex < activityJson.InputControls.length - 1) {
                setAnimeClick(true)
                setIsPalleteClose(false)
                setCurrentSlideIndex(
                  (currentSlideIndex) => currentSlideIndex + 1
                )
                setInitial(true)
              }
            }
          }}
        >
          <ArrowForwardIosRoundedIcon
            style={{ width: '20px', height: '20px', color: '#4922fd' }}
          />
        </div>
      </div>
    )
  }

  function renderSlideNumber() {
    return (
      <div className='pallete-cont'>
        {!isPalleteClose && (
          <div className='slide-palette-div'>
            <span
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <div
                className={animeClick ? 'slide-index-prev' : 'slide-index-prev'}
              >
                {previousSlideIndexes.length > 0 &&
                  previousSlideIndexes.map((prevItem, index) => {
                    return (
                      <span
                        // className={animeClick ? "anime-left" : ""}
                        key={index + 'p'}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        <div
                          className='slide-number-container'
                          onClick={() => {
                            if (isBgAudioPlayed) {
                              setCurrentSlideIndex(prevItem)
                            }
                          }}
                        >
                          <p className='slide-number-label'>{prevItem + 1}</p>
                        </div>
                        <span
                          style={{
                            width: '30px',
                            height: '3px',
                            backgroundColor: '#dfdfdf'
                          }}
                        />
                      </span>
                    )
                  })}
              </div>
              <div>
                <span
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                  }}
                >
                  <div className='slide-number-container slide-number-container-selected'>
                    <p className='slide-number-label slide-number-label-selected'>
                      {currentSlideIndex + 1}
                    </p>
                  </div>
                </span>
              </div>
              <div
                className={animeClick ? 'slide-index-next' : 'slide-index-next'}
              >
                {nextSlideIndexes.length > 0 &&
                  nextSlideIndexes.map((prevItem, index) => {
                    return (
                      <span
                        id={index + 'n'}
                        //  className={animeClick ? "anime-left" : ""}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        <span
                          style={{
                            width: '30px',
                            height: '3px',
                            backgroundColor: '#dfdfdf'
                          }}
                        />
                        <div
                          className='slide-number-container'
                          onClick={() => {
                            if (isBgAudioPlayed) {
                              setCurrentSlideIndex(prevItem)
                            }
                          }}
                        >
                          <p className='slide-number-label'>{prevItem + 1}</p>
                        </div>
                      </span>
                    )
                  })}
              </div>
            </span>
          </div>
        )}

        <div className='slide-arrow-cont'>
          <div
            className='footer-arrow-cont'
            onClick={() => {
              if (isBgAudioPlayed) {
                setIsPalleteClose((floating) => !floating)
              }
            }}
          >
            {isPalleteClose ? (
              <CaretUp color='#4922FD' size={22} />
            ) : (
              <CaretDown color='#4922FD' size={22} />
            )}
          </div>
        </div>
      </div>
    )
  }

  function renderSlidePal() {
    return (
      <div className='slide-navigation-container'>
        {renderSlideFloating()}
        {!isPalleteClose && renderSlideNumber()}
      </div>
    )
  }

  return (
    <section
      style={{ backgroundColor: '#e0e0e0', width: '100%', height: '100%' }}
    >
      {/* {renderSlidePalette()} */}
      {renderSlidePal()}
      <div
        style={{
          height: '100%',
          width: '100%',
          backgroundColor: '#e0e0e0'
        }}
      >
        <div
          style={{
            height: '100%',
            fontFamily: fontFamily,
            fontStyle: fontStyle ? 'italic' : 'normal',
            fontWeight: fontWeight ? 'bold' : 'normal'
          }}
        >
          {smartSlideData && Object.keys(smartSlideData).length > 0 && (
            <SmartSlideBaseScreen
              user={user}
              initial={initial}
              Completed={Completed}
              smartSlideData={smartSlideData}
              isPractice={isPractice}
              isActive={isActive}
              isVerifyMode={isVerifyMode}
              explanationClick={explanationClick}
              screenMode={'desktop'}
              timerEnd={false}
              controlsList={controlsList}
              isResetClick={isResetClick}
              handleValueChange={handleValueChange}
              handleAttemptsChange={handleAttemptsChange}
              setExplanationText={(parentExplanationText) => {
                setExplanationText(parentExplanationText)
              }}
              setExplanationStatus={(parentExplanationStatus) => {
                setExplanationStatus(parentExplanationStatus)
              }}
              setExplanationVisible={(parentExplanationVisible) => {
                setExplanationVisible(parentExplanationVisible)
              }}
              setExplanationClick={(parentExplanationClick) => {
                setExplanationClick(parentExplanationClick)
              }}
              audioStop={audioStop}
              setOldJson={(oldJsonStatus) => {
                setOldJson(oldJsonStatus)
              }}
              handleSuccessModal={(successModalValue) => {
                handleSuccessChange(successModalValue)
              }}
              isTtsPlay={tutorialStart}
              isBgAudioPlayed={isBgAudioPlayed}
              canvasAreaDimensions={canvasAreaDimensions}
              onVideoPlaying={(videoStatus) => {
                if (videoStatus) {
                  setIsPalleteClose(true)
                }
                // console.log("videoStatus", videoStatus);
              }}
            />
          )}
        </div>
      </div>

      {/* <AnswerExplanation
        explanationVisible={explanationVisible}
        explanationStatus={explanationStatus}
        explanationText={explanationText}
        onExplanationClosed={() => {
          setExplanationVisible(false);
          setExplanationClick(false);
        }}
      /> */}
      {isBgAudioPlayed && botAudioData !== '' && (
        <BotAssistSettings
          audioUrl={botAudioData}
          text={ttsData}
          tutorialStart={tutorialStart}
          botType={ttsPlayType}
          getTutorTalking={(audioStatus) => {
            setIsAudioPlaying(audioStatus)
            getTutorTalking(audioStatus)
          }}
          isAudioForcedStopped={isAudioForcedStopped}
          isMinimize={isMinimize}
          onBotComplete={() => {
            setTutorialStart(false)
            setIsTutorPlayed(true)
          }}
          onBotStopped={() => {
            setTutorialStart(false)
          }}
          onFrwdSkipClick={() => {}}
        />
      )}
    </section>
  )
}

export { SmartSlideMainScreen }
